'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: { isProduction: false },
  production: { isProduction: true }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  protocol: process.env.PROTOCOL || 'http',
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  apiHost: process.env.APIHOST || 'localhost',
  apiPort: process.env.APIPORT,
  apiRoot: process.env.APIROOT || '',
  cookieHttpOnly: process.env.COOKIEHTTPONLY || true,
  cookieSigned: process.env.COOKIESIGNED || false,
  sessionSecretKey: process.env.sessionKey || 'TravelportSecret!2016',
  app: {
    title: 'TripQuotes',
    description: 'SmartPointPro TripQuotes Admin website.',
    // homeUrl: 'https://smartpointpro-cloud.pp.travelport.com:6001/Web/Account/LandingPage',
    // homeUrl: 'http://localhost:1611/Web/Account/LandingPage',
    homeUrl: '/',
    head: {
      titleTemplate: 'TripQuotes - %s',
      meta: [{ name: 'description', content: 'Travelport SmartPointPro TripQuotes Admin website.' }, { charset: 'utf-8' }, { property: 'og:site_name', content: 'TripQuotes' }, { property: 'og:locale', content: 'en_US' }, { property: 'og:title', content: 'TripQuotes' }, { property: 'og:description', content: 'Travelport SmartPointPro TripQuotes Admin site.' }, { property: 'og:site', content: 'Travelport' }]
    }
  }
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 236
// module chunks = 0